module.exports = __webpack_public_path__ + "static/p3-118d689a79f33ed9dc37aa359130cef7.jpg";